export default "__VITE_ASSET__d0bf8eaf__"